import { useState, useMemo } from "react";
import PageHeader from "@/components/layout/PageHeader";
import ContactBlock from "@/components/sections/ContactBlock";
import { GALLERY } from "@/lib/site";

const CATEGORIES = ["All", "ADU Projects", "Plumbing", "HVAC", "Remodels", "Construction", "Drywall"];

export default function GalleryPage() {
  const [active, setActive] = useState("All");
  const items = useMemo(() => active === "All" ? GALLERY : GALLERY.filter((g) => g.category === active), [active]);

  return (
    <div data-testid="gallery-page">
      <PageHeader
        overline="Gallery"
        title="Recent projects across Los Angeles."
        sub="A glimpse at our construction, plumbing, HVAC, drywall and remodeling work — clean, finished and built to last."
        image="https://images.unsplash.com/photo-1711426793020-9eb590f2fc12"
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Gallery" }]}
      />

      <section className="section-pad">
        <div className="container-page">
          <div className="flex flex-wrap gap-2 mb-8" data-testid="gallery-filters">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                data-testid={`gallery-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-2 rounded-sm border text-xs font-bold uppercase tracking-[0.18em] transition ${
                  active === c
                    ? "bg-brand-obsidian text-white border-brand-obsidian"
                    : "bg-white border-brand-line text-brand-ink hover:border-brand-obsidian"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {items.length === 0 ? (
            <p className="body-base text-center py-16">More projects coming soon.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {items.map((g, i) => (
                <figure key={i} data-testid={`gallery-item-${i}`} className="group rounded-md overflow-hidden border border-brand-line bg-white">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={g.src} alt={g.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                  </div>
                  <figcaption className="p-4">
                    <p className="overline">{g.category}</p>
                    <p className="font-heading font-bold text-brand-ink mt-1.5">{g.title}</p>
                  </figcaption>
                </figure>
              ))}
            </div>
          )}
        </div>
      </section>

      <ContactBlock source="gallery_page" />
    </div>
  );
}
